import { springAdminRequest } from "./springAdminApi";

export type AdminNotification = {
  id: number;
  event_key: string;
  event_type: "ONLINE_APPRAISAL_REQUEST" | "CHATBOT_APPRAISAL_REQUEST" | string;
  source_id: number;
  title: string;
  content: string;
  page?: string | null;
  page_id?: number | null;
  is_read: boolean;
  created_at: string;
  updated_at: string;
};

export type AdminWebPushTokenRequest = {
  token: string;
  browserInfo?: string;
};

type AdminNotificationListResponse = {
  message: string;
  data: AdminNotification[];
  unreadCount?: number;
  unread_count?: number;
};

export const adminNotificationApi = {
  list: () => springAdminRequest.get<AdminNotificationListResponse>("notifications"),
  markAsRead: (id: number) => springAdminRequest.put(`notifications/${id}/read`),
  markAllAsRead: () => springAdminRequest.put("notifications/read-all"),
  registerWebPushToken: (request: AdminWebPushTokenRequest) =>
    springAdminRequest.put("notifications/web-push-token", request),
  unregisterWebPushToken: (request: AdminWebPushTokenRequest) =>
    springAdminRequest.delete("notifications/web-push-token", { data: request }),
};

export const getUnreadCount = (response: AdminNotificationListResponse) =>
  response.unread_count ?? response.unreadCount ?? response.data.filter((item) => !item.is_read).length;
